import { IMedsusDocumento } from '../../modules/types/Medsus';
import httpClient from '../httpClient';

/**
 * Busca todos os registros de documentos/exames MedSUS.
 */
export const getAllMedsusDocumento = async (): Promise<IMedsusDocumento[]> => {
  try {
    const response = await httpClient.get('/api/medsusdocumento');
    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error(
      'Erro ao obter lista de documentos MedSUS: ' + error.message,
    );
  }
};

/**
 * Busca todos os registros de documentos pelo ID do Diretriz.
 */
export const getAllMedsusDocumentoByDiretrizVmp = async (
  diretrizVmpId: string,
) => {
  try {
    const response = await httpClient.get(
      `/api/medsusdocumento/diretriz/${diretrizVmpId}`,
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

/**
 * Busca um documento/exame específico pelo ID.
 */
export const getMedsusDocumentoById = async (
  id: string | number,
): Promise<IMedsusDocumento> => {
  try {
    const response = await httpClient.get(`/api/medsusdocumento/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao obter documento MedSUS: ' + error.message);
  }
};

/**
 * Cria um novo documento/exame MedSUS.
 */
export const handleCreateMedsusDocumento = async (
  form: IMedsusDocumento,
): Promise<any> => {
  try {
    console.log(form);
    const response = await httpClient.post('/api/medsusdocumento', form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao criar documento MedSUS: ' + error.message);
  }
};

/**
 * Atualiza um documento/exame MedSUS existente.
 */
export const handleUpdateMedsusDocumento = async (
  form: IMedsusDocumento,
): Promise<any> => {
  try {
    const response = await httpClient.patch(
      `/api/medsusdocumento/${form.id}`,
      form,
    );
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao atualizar documento MedSUS: ' + error.message);
  }
};

/**
 * Realiza exclusão lógica (soft delete) de um documento/exame MedSUS.
 */
export const handleDeleteMedsusDocumento = async (
  id: string | number,
): Promise<any> => {
  try {
    const response = await httpClient.delete(`/api/medsusdocumento/${id}`);
    return response.data; // { message }
  } catch (error: any) {
    throw new Error('Erro ao excluir documento MedSUS: ' + error.message);
  }
};
